import React, { useEffect, useState } from 'react';
import axios from 'axios';
import InvestorPortalLayout from '../../../components/market/InvestorPortalLayout';
import { useInvestorAuth } from '../../../context/InvestorAuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function InvestorPortalDocuments() {
  const { token } = useInvestorAuth();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Reuse the bid-level DD room manifest endpoint by pulling from /bids
        // for any active bid with a DD room. For investor-level NDA / sub
        // docs the admin side panel is the canonical source today; we'll
        // surface a stub here until the read-only investor-docs endpoint
        // ships.
        const r = await axios.get(`${API_URL}/api/market/bids`, { headers: { Authorization: `Bearer ${token}` } });
        if (!mounted) return;
        setDocs(r.data?.bids || []);
      } catch {} finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, [token]);

  return (
    <InvestorPortalLayout>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#111111' }}>My Documents</h1>
        <p style={{ margin: '4px 0 24px', fontSize: 13, color: '#6b7280' }}>
          LOIs, PSAs, and bid-level due-diligence packages.
        </p>

        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 12 }}>Bid-Level Documents</div>
          {loading ? (
            <div style={{ color: '#9ca3af', fontSize: 13 }}>Loading…</div>
          ) : docs.length === 0 ? (
            <div style={{ fontSize: 13, color: '#6b7280' }}>
              No bid documents yet. Documents (LOIs, PSAs, due-diligence packages) appear here once you have an active bid.
            </div>
          ) : (
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, color: '#374151', lineHeight: 1.8 }}>
              {docs.map((b) => (
                <li key={b.id}>
                  <strong>{b.pool_name || b.pool_number || `Bid #${b.id}`}</strong>
                  {b.status ? <span style={{ color: '#9ca3af' }}> — {b.status.replace('_', ' ')}</span> : null}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </InvestorPortalLayout>
  );
}
